const safeUrl = (face = "") => {
  return face.replace("http:", "https:");
};

export default safeUrl;
